<div coreTitle>Error</div>
<h5 i18n>There was an error navigating</h5>
<pre>{{ error }}</pre>
<a mat-raised-button color="primary" [routerLink]="'/home'" i18n>Continue</a>
